const WorkExperience = [
    {
        id: 1,
        title: "Lead Developer & Technical Support Engineer",
        company: "Time Piece Lifestyle LLC",
        yearsActive: "Jun. 2026 – Present",
        information: [
            "Engineered and launched the company’s core web application, integrating payment systems and custom market analytics tools.",
            "Managed technical support engineering, maintaining system uptime, resolving platform bugs, and ensuring platform stability."
        ],
    },
    {
        id: 3,
        title: "Co-Founder & Lead Developer",
        company: "ISHMARKAZ",
        yearsActive: "Dec. 2024 – Apr. 2025",
        information: [
            "Co-founded a regional job board website to help unemployed people in Uzbekistan find open job positions.",
            "Built the full-stack web application with an engineering team while leading technical support to troubleshoot system errors, fix bugs, and ensure platform stability."
        ],
    }
];

export default WorkExperience;
